import React, { useEffect, useRef, useState } from "react";
import DashboardHeader from "../../../components/dashboardHeader";
import CustomContainer from "../../../components/container/CustomContainer";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import GlobalButton from "../../../components/button";
import AddEditAddressDialog from "./AddEditAddressDialog";
import AppLoader from "../../../components/apploader";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { deleteUserAddress, getUserAddress } from "../../../services/addressFn";
import { useSelector } from "react-redux";
import DynamicTable from "./../../../components/table/index";
import DeleteAlert from "../../../components/alert/DeleteAlert";
import { t } from "i18next";

const headerData = [
  "fullName",
  "email",
  "contact",
  "country",
  "state",
  "city",
  "zipCode",
  "address",
  "action",
];

const tableRows = [
  "user_name",
  "email",
  "contact",
  "country",
  "state",
  "city",
  "zipCode",
  "address",
  "actions",
];

const UserAddressBookPage = () => {
  const openDialog = useRef();
  const openDeleteAlert = useRef();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState();
  const [allUserAddress, setAllUserAddress] = useState([]);
  const userData = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (userData) {
      fetchUserAddress();
    }
  }, [userData]);

  const fetchUserAddress = async () => {
    try {
      setIsLoading(true);
      const response = await getUserAddress(userData?._id);
      if (response.data.status === "success") {
        let data = response?.data.data;
        setAllUserAddress(data);
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeadProps = () => {
    return (
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={"center"}
        spacing={2}
      >
        <GlobalButton
          handleClickBtn={() =>
            openDialog.current.openDialog({
              type: "add",
              getData: fetchUserAddress,
              data: null,
            })
          }
          btnText={t("addAddress")}
          styleProps={{
            width: "auto",
          }}
        />
      </Stack>
    );
  };

  const handleOpenEditDialog = (params) => {
    openDialog.current.openDialog({
      type: "edit",
      getData: fetchUserAddress,
      data: params.row,
    });
  };

  const handleOpenDeleteAlert = (params) => {
    openDeleteAlert.current.openDialog({
      warningText: t("addressDeleteMessage"),
      data: params.row,
    });
  };

  const handleDeleteRow = async (params) => {
    try {
      setIsLoading(true);
      const response = await deleteUserAddress(params.data._id);
      if (response.data.status === "success") {
        fetchUserAddress();
        openDeleteAlert.current.closeDialog();
        showSnackbar(response.data.message, "success");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("addressBook")}
        secondaryHeading={t("addEditDeleteAddress")}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
        headProps={renderHeadProps()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allUserAddress || []}
          showActions={true}
          showDelete={true}
          showEdit={true}
          handleEdit={handleOpenEditDialog}
          handleDelete={handleOpenDeleteAlert}
        />
      </CustomContainer>
      <AddEditAddressDialog ref={openDialog} />
      <DeleteAlert ref={openDeleteAlert} onDelete={handleDeleteRow} />
    </DashboardHeader>
  );
};

export default UserAddressBookPage;
